import { z } from 'zod';
const baseFields = {
    description: z.string().min(10, 'La descripción debe tener al menos 10 caracteres').max(2000),
};
const shiftChangeMetadata = z.object({
    desired_shift_id: z.string().uuid(),
    reason: z.string().max(500).optional(),
});
const singleClassChangeMetadata = z.object({
    from_class_id: z.string().uuid(),
    to_class_id: z.string().uuid(),
});
const classMaterialAccessMetadata = z.object({
    schedule_class_id: z.string().uuid(),
});
const temporaryLeaveMetadata = z.object({
    reason: z.string().min(5).max(500),
    expected_return_date: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/, 'Fecha inválida (YYYY-MM-DD)')
        .optional(),
});
const dataCorrectionMetadata = z.object({
    field_to_correct: z.string().max(100),
    current_value: z.string().max(500),
    desired_value: z.string().max(500),
});
const emptyMetadata = z.record(z.unknown()).optional();
export const createRequestSchema = z.discriminatedUnion('type', [
    z.object({ type: z.literal('shift_change'), ...baseFields, metadata: shiftChangeMetadata }),
    z.object({ type: z.literal('single_class_change'), ...baseFields, metadata: singleClassChangeMetadata }),
    z.object({ type: z.literal('class_material_access'), ...baseFields, metadata: classMaterialAccessMetadata }),
    z.object({ type: z.literal('temporary_leave'), ...baseFields, metadata: temporaryLeaveMetadata }),
    z.object({ type: z.literal('data_correction'), ...baseFields, metadata: dataCorrectionMetadata }),
    z.object({ type: z.literal('data_export'), ...baseFields, metadata: emptyMetadata }),
    z.object({ type: z.literal('data_deletion'), ...baseFields, metadata: emptyMetadata }),
    z.object({ type: z.literal('recorded_class'), ...baseFields, metadata: emptyMetadata }),
    z.object({ type: z.literal('online_class_access'), ...baseFields, metadata: emptyMetadata }),
    z.object({ type: z.literal('other'), ...baseFields, metadata: emptyMetadata }),
]);
export const resolveRequestSchema = z.object({
    status: z.enum(['approved', 'rejected']),
    resolution_notes: z.string().max(2000).optional(),
    // For 'recorded_class' requests: one or more recordings the director grants on
    // approval (a request can reference several recordings).
    recording_ids: z.array(z.string().uuid()).min(1).optional(),
    // For 'class_material_access' requests: specific materials to grant. When
    // omitted, ALL of the class's materials are granted (the original behaviour).
    material_ids: z.array(z.string().uuid()).min(1).optional(),
});
//# sourceMappingURL=request.schema.js.map